import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Personal Value No. 1: Seek first to understand, then to be understood. - Stephen R. Covey
        </p>
        <a
          className="App-link"
          href="https://www.linkedin.com/in/shaun-koh-a089a739"
	  target="_blank"
	  rel="noreferrer noopener"
        >
          LinkedIn
        </a>
      </header>
    </div>
  );
}

export default App;
